import { defineComponent as _defineComponent } from 'vue'
import { Typo } from '@travelata-libs/ui-kit';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';

    interface BonusMilesContentProps {
        tooltipType: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BonusMilesTooltip',
  props: {
    tooltipType: { default: 'black' }
  },
  setup(__props: any) {

    

return { __sfc: true,Typo, HintTooltip }
}

})